import React, { useEffect } from "react";
import { HiOutlineX } from "react-icons/hi";

const SidePanel = ({ isOpen, onClose, title, children }) => {
  // Prevent scrolling when panel is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex justify-end">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity animate-fadeIn"
        onClick={onClose}
      />

      {/* Panel */}
      <div className="relative w-full max-w-xl bg-[#0b0e14]/90 backdrop-blur-3xl border-l border-white/10 h-full shadow-[-20px_0_50px_rgba(0,0,0,0.5)] flex flex-col animate-slideInRight">
        {/* Background Glow */}
        <div className="absolute top-0 right-0 w-full h-[500px] bg-cyan-500/5 rounded-full blur-[120px] pointer-events-none" />

        {/* Header */}
        <div className="p-8 border-b border-white/5 flex items-center justify-between relative z-10 bg-black/20">
          <div>
            <h3 className="text-xl font-black text-white uppercase italic tracking-tighter">
              {title}
            </h3>
            <div className="h-1 w-12 bg-cyan-400 mt-2 rounded-full shadow-[0_0_10px_#00f2ff]" />
          </div>
          <button
            onClick={onClose}
            className="p-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl transition-all text-gray-400 hover:text-red-400 group"
          >
            <HiOutlineX
              size={24}
              className="group-hover:rotate-90 transition-transform duration-300"
            />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-8 relative z-10 custom-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
